import {
  AdoTestPlan,
  JiraTestPlan,
  TestPlan,
} from '../../interfaces/ui/testPlan';
import { mapJiraTestSuites } from './testSuite.response.dto';

import { ProjectMappingType } from '../../interfaces/ui/addProjectModal';

function mapJiraTestPlans(testPlanData: any[]): JiraTestPlan[] {
  return testPlanData.map(testPlan => {
    return {
      id: testPlan.id,
      name: testPlan.name,
      sequence: testPlan.sequence,
      parentId: testPlan.parentId,
      children: mapJiraTestSuites(testPlan.children || []),
      created: {
        by: testPlan.created.by,
        on: new Date(testPlan.created.on),
      },
      updated: {
        by: testPlan.updated.by,
        on: new Date(testPlan.updated.on),
      },
    };
  });
}

function mapAdoTestPlans(testPlanData: any[]): AdoTestPlan[] {
  return testPlanData.map(testPlan => {
    return {
      id: testPlan.id,
      name: testPlan.name,
      iteration: testPlan.iteration,
      url: testPlan.url,
    };
  });
}

export function mapTestPlanResponse(
  response: any,
  tool: ProjectMappingType,
): TestPlan[] {
  if (!response) {
    return [];
  }
  let mapped: TestPlan[] = [];
  switch (tool) {
    case 'ADO':
      const adoData = response?.data?.testplans?.value;
      if (!adoData) return [];
      mapped = mapAdoTestPlans(adoData);
      break;
    case 'JIRA':
      const jiraData = response?.data?.testplans?.data;
      if (!jiraData) return [];
      mapped = mapJiraTestPlans(jiraData);
      break;
  }
  return mapped;
}
